import { render } from "./BlogHeader.vue?vue&type=template&id=2de48879&scoped=true"
import script from "./BlogHeader.vue?vue&type=script&lang=js"
export * from "./BlogHeader.vue?vue&type=script&lang=js"

import "./BlogHeader.vue?vue&type=style&index=0&id=2de48879&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de48879"]])

export default __exports__